<template>
  <div id="app7">
      <Carousel_new1 :vertical='false' :verticalS='false' :items='3' :rows='1' :controls='false' :texts="texts" :titles="titles" :toptitles="toptitles"/>
  </div>
</template>

<script>
import Carousel_new1 from './components/Carousel_new1';

export default {
  name: 'AppB',
  components: {
    Carousel_new1,
  },
  slides: [
      "https://vue.anvetogroup.com/wp-content/uploads/2022/06/vlefaroplastiki.jpg",
      "https://vue.anvetogroup.com/wp-content/uploads/2022/06/botox.jpg"
    ],
    texts:[
      'A piece of the past, reclaimed wood is a unique flooring that comes with a story to tell. Provide your home a beautifully distressed, handcrafted look with a sense of history.',
      'A piece of the past, reclaimed wood is a unique flooring that comes with a story to tell. Provide your home a beautifully distressed, handcrafted look with a sense of history.',
      'A piece of the past, reclaimed wood is a unique flooring that comes with a story to tell. Provide your home a beautifully distressed, handcrafted look with a sense of history.',
      'A piece of the past, reclaimed wood is a unique flooring that comes with a story to tell. Provide your home a beautifully distressed, handcrafted look with a sense of history.',
      'A piece of the past, reclaimed wood is a unique flooring that comes with a story to tell. Provide your home a beautifully distressed, handcrafted look with a sense of history.',
      'A piece of the past, reclaimed wood is a unique flooring that comes with a story to tell. Provide your home a beautifully distressed, handcrafted look with a sense of history.',
    ],
    titles:[
      'RECLAIMED FLOORING',
      'RECLAIMED FLOORING',
      'RECLAIMED FLOORING',
      'RECLAIMED FLOORING',
      'RECLAIMED FLOORING',
      'RECLAIMED FLOORING',
    ],
    toptitles:[
      'PRODUCTS',
      'PRODUCTS',
      'PRODUCTS',
      'PRODUCTS',
      'PRODUCTS',
      'PRODUCTS',
    ]
}
</script>
